'use client';
import type { FC } from 'react';
import { useState, useCallback, useRef, useLayoutEffect } from 'react';
import { css } from '@styled-system/css';
import { Box } from '@styled-system/jsx';

const MAX_LINES_IN_DESCRIPTION = 3;

type Props = {
  description: string;
};

export const Description: FC<Props> = ({ description }) => {
  const descRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [readMoreVisible, setReadMoreVisible] = useState(false);

  useLayoutEffect(() => {
    if (descRef.current) {
      setReadMoreVisible(
        descRef.current.scrollHeight > descRef.current.clientHeight
      );
    }
  }, []);

  const expand = useCallback(() => {
    setExpanded(true);
  }, []);

  return (
    <Box width="100%" position="relative" marginTop="16px">
      <Box
        ref={descRef}
        color="accent.700"
        overflow="hidden"
        boxOrient="vertical"
        lineClamp={expanded ? 0 : MAX_LINES_IN_DESCRIPTION}
        w="100%"
        fontSize="size_14"
        maxWidth="1080px"
        margin="auto"
        display={expanded ? 'block' : '-webkit-box'}
      >
        {description}
        {readMoreVisible && !expanded && (
          <button
            className={css({
              position: 'absolute',
              cursor: 'pointer',
              bottom: '4px',
              right: '0',
              paddingLeft: '40px',
              backgroundImage:
                'linear-gradient(270deg, #FAFAFA 88.33%, rgba(250, 250, 250, 0.00) 107.22%)',
              outline: 'none',
              fontSize: 'size_12',
              fontWeight: '700',
              lineHeight: '14px',
            })}
            onClick={expand}
          >
            もっと読む
          </button>
        )}
      </Box>
    </Box>
  );
};
